import { render, staticRenderFns } from "./PartEdit.vue?vue&type=template&id=52f4f40a"
import script from "./PartEdit.vue?vue&type=script&lang=ts"
export * from "./PartEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports